const useScreenWidthSize = () => {
	// fixme: I tried to use the hook useMediaQuery but during different
	// renders the method was being called different number of times
	// causing the rules of hooks to be violated.
	let val;
	if (window.innerWidth <= 360) {
		val = 'sm';
	} else if (window.innerWidth > 360 && window.innerWidth <= 768) {
		val = 'md';
	} else if (window.innerWidth > 768 && window.innerWidth <= 1024) {
		val = 'lg';
	} else if (window.innerWidth > 1024 && window.innerWidth <= 1444) {
		val = 'xl';
	} else if (window.innerWidth > 1444 && window.innerWidth <= 1920) {
		val = 'xxl';
	} else if (window.innerWidth > 1920) {
		val = 'jumbo';
	}
	return val;
};

export default useScreenWidthSize;
